import type { LaunchDayView } from '@doneverse/shared'
import { api, isNotFoundError } from '../api/index.js'

/**
 * Onboarding step 10 — Launch Day (ClickUp `86d40tuc8`).
 *
 * Two calls, both founder-only, and both answering with the WHOLE view so the
 * client never has to work out whether the step just closed.
 */
export const launchDayService = {
  /**
   * When the founder's first day with their Doer is, and whether it has come.
   *
   * Null on a 404 — the founder has no onboarding run at all (the grandfathered
   * cohort). That is an empty state, not a failure, so it must not reach an
   * error boundary.
   */
  fetch: async (): Promise<LaunchDayView | null> => {
    try {
      return await api.get('/v1/onboarding/launch-day').json<LaunchDayView>()
    } catch (error: unknown) {
      if (isNotFoundError(error)) return null
      throw error
    }
  },

  /**
   * Press "Next" — close step 10, which closes the journey.
   *
   * 409s when the launch day has not arrived. The button that calls this is
   * disabled until `launchDateReached`, so a 409 means the client and the server
   * disagree about whose day it is (a tab left open across midnight, most
   * likely) — the caller refetches rather than insisting.
   */
  complete: (): Promise<LaunchDayView> =>
    api.post({}, '/v1/onboarding/launch-day/complete').json<LaunchDayView>(),
}
